var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-render"},[_c('div',{key:_vm.value,staticClass:"markdown-content",style:(_vm.textStyle),domProps:{"innerHTML":_vm._s(_vm.markdown(_vm.value))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }